module.exports = __webpack_public_path__ + "img/dianzan.f4ca6077.png";